"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePreloader = void 0;
const react_1 = __importDefault(require("react"));
function usePreloader({ skip, status, onLoad, onSuccess, onError, refreshOnMount }) {
    const cache = react_1.default.useRef();
    react_1.default.useEffect(() => {
        if (skip || status === 'loading') {
            return;
        }
        let ignore = false;
        if (status === 'initial' || (refreshOnMount && (status === 'done' || status === 'error'))) {
            if (!cache.current) {
                cache.current = onLoad().finally(() => {
                    cache.current = undefined;
                });
            }
            cache.current
                .then((result) => {
                if (!ignore) {
                    onSuccess(result);
                }
            })
                .catch((error) => {
                if (!ignore) {
                    onError(error);
                }
            });
            return;
        }
        return () => {
            ignore = true;
        };
    }, [status, onLoad, refreshOnMount]);
    return {
        status: skip ? 'done' : status,
        onReload: () => onLoad().then(onSuccess).catch(onError),
    };
}
exports.usePreloader = usePreloader;
